let prod = false;
if(process.env.NODE_ENV==='production') {
  prod = true;
}
let host  = window.location.host;
let protocol = window.location.protocol;
if(host == "localhost:3000") {
  host = protocol + "//local-osha2.docksal";
} else {
  host = protocol + "//" + host;
}
const mode = {
  staticAPI: false,
  loginSucceeds: true,
  prod: prod,
  host: host,
  debug: false
};

export default mode;



/** WEBPACK FOOTER **
 ** ./src/api/mode.js
 **/